import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { WORKSPACE_ID } from './constants';

interface FloatingFormProps {
  x: number;
  y: number;
  isLeftAttachment?: boolean;
}

const StyledFloatingFormWrapper = styled.div<{
  top: number;
  left: number;
}>`
  top: ${(props) => `${props.top + 20}px`};
  left: ${(props) => `${props.left}px`};
  position: absolute;
  min-width: 1px;
  z-index: 10;
  padding: var(--spacing-03);
  min-width: 400px;
  max-height: 700px;
`;

export const FloatingComponent: React.FC<FloatingFormProps> = React.memo(
  ({ x, y, isLeftAttachment, children }) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const canvasRef = useRef<HTMLElement | null>(null);
    const preview = document.getElementById(WORKSPACE_ID) as HTMLElement;
    const [xPosition, setXPosition] = useState<'left' | 'right'>(
      isLeftAttachment ? 'right' : 'left',
    );
    const [yPosition, setYPosition] = useState<'top' | 'bottom'>('top');

    useEffect(() => {
      if (ref.current && preview) {
        if (canvasRef.current === null) {
          const iframe = document.querySelector(
            '#webviewer-1',
          ) as HTMLIFrameElement;

          if (iframe) {
            const canvas = iframe.contentDocument?.querySelector(
              '#pageWidgetContainer1',
            );

            if (canvas) {
              canvasRef.current = canvas as HTMLElement;
            }
          }
        }
        if (
          ref.current.getBoundingClientRect().right >
          (canvasRef.current ?? preview).getBoundingClientRect().right
        ) {
          setXPosition('right');
        } else {
          setXPosition('left');
        }
        if (
          ref.current.getBoundingClientRect().bottom >
          (canvasRef.current ?? preview).getBoundingClientRect().bottom
        ) {
          setYPosition('bottom');
        } else {
          setYPosition('top');
        }
      }
    }, [ref, preview]);

    return ReactDOM.createPortal(
      <StyledFloatingFormWrapper
        ref={(_curr) => {
          ref.current = _curr;
        }}
        left={xPosition === 'right' ? x - 425 - 48 : x}
        top={
          yPosition === 'bottom'
            ? y -
              (ref.current && ref.current?.getBoundingClientRect().height > 700
                ? 300
                : 250)
            : ref.current &&
              ref.current.getBoundingClientRect().top <
                (canvasRef.current ?? preview).getBoundingClientRect().top + 100
            ? y - 50
            : y - 100
        }
        style={{
          maxHeight:
            ref.current && ref.current?.getBoundingClientRect().height > 700
              ? '350px'
              : 'unset',
          maxWidth:
            ref.current && ref.current?.getBoundingClientRect().height > 700
              ? '400px'
              : 'unset',
          overflowY:
            ref.current && ref.current?.getBoundingClientRect().height > 700
              ? 'auto'
              : 'unset',
        }}
      >
        {children}
      </StyledFloatingFormWrapper>,
      document.getElementById(WORKSPACE_ID) as HTMLElement,
    );
  },
);
